var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDQoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.38896 1.21687V3.8146C7.38896 4.16691 7.09543 4.45237 6.73333 4.45237C5.44143 4.45237 4.73869 5.74161 4.64129 8.28613H6.73333C7.09543 8.28613 7.38896 8.57186 7.38896 8.92404L7.38896 14.409C7.38896 14.7611 7.09543 15.0467 6.73333 15.0467H1.15549C0.793252 15.0467 0.5 14.7609 0.5 14.409L0.5 8.92404C0.5 7.70424 0.62623 6.58488 0.875068 5.59667C1.13028 4.5834 1.52203 3.69745 2.03909 2.96335C2.57115 2.20892 3.23667 1.6169 4.01733 1.20447C4.80327 0.789551 5.71722 0.579102 6.73356 0.579102C7.09543 0.579102 7.38896 0.864562 7.38896 1.21687ZM15.8443 4.45242C16.2062 4.45242 16.5 4.16669 16.5 3.81465V1.21692C16.5 0.864607 16.2063 0.579146 15.8443 0.579146C14.8284 0.579146 13.9143 0.78964 13.1286 1.20452C12.3478 1.61695 11.682 2.20896 11.1498 2.96339C10.6329 3.69749 10.2412 4.58349 9.98593 5.59698C9.73722 6.5855 9.611 7.70487 9.611 8.92408V14.4091C9.611 14.7612 9.90461 15.0467 10.2666 15.0467H15.8443C16.2062 15.0467 16.4997 14.761 16.4997 14.4091V8.92404C16.4997 8.57191 16.2062 8.28613 15.8443 8.28613H13.7821C13.878 5.74165 14.5705 4.45242 15.8443 4.45242Z",
    fill: "#6D597A",
    fillOpacity: 0.28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDQoute);
export default __webpack_public_path__ + "static/media/d-qoute.42a73721840b629ba6f21c6ae83d542d.svg";
export { ForwardRef as ReactComponent };